import { Model } from 'jms-domain'

import { configuratorInterface } from '../systems/configurator-interface.js'

/**
 * Clean up all entities on shape change.
 */
export const resetStainlessSafeEnvironmentTransformer = configuratorInterface.transformerBuilder.when
  .entity(['Room'])
  .modified({ atFields: ['powderCoatType'] })
  .and(ctx => ctx.getNew$Entity().powderCoatType !== Model.PowderCoatType.Anvil)
  .then.applySideEffect(ctx => {
    return [
      configuratorInterface.updates.DomainEntityModification({
        entityId: ctx.getOld$Root().id,
        stateDelta: {
          stainlessSafeEnvironment: false,
        },
        updateTag: 'resetStainlessSafeEnvironment',
      }),
    ]
  })
  .build('Set room to be not "stainless safe" when user changes powder coat type.')
